<template>
  <div>
    <div v-if="mobile == 0">
      <div class="bg-main">
        <el-carousel :height="bannerHeight+'PX'" trigger="click">
          <el-carousel-item v-for="item in imgUrl" :key="item.id">
            <img class="bannertt" style="width: 100%; height: auto;" ref=bannerHeight :src=item.imgV alt=""
              @load="imgload">
            <div v-if="item.id==0" class="bg1-text">
            </div>
            <div v-if="item.id==1" class="bg-text">
            </div>
            <div v-if="item.id==2" class="bg-text">
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="text-div">
        <div class="left text">
          <img src="../assets/vip_icon.png" alt="">
          <span class="text-title">{{$t("home.lenovoVip")}}</span>
          <span class="text-span">{{$t("home.lenovoVipText")}}</span>
          <el-link :underline="false" class="go-more" @click="more" type="primary">{{$t('home.more')}}</el-link>
        </div>
        <div class="left text">
          <img src="../assets/user_icon.png" alt="">
          <span class="text-title">{{$t("home.accountSecurity")}}</span>
          <span class="text-span">{{$t("home.accountSecurityText")}}</span>
        </div>
        <div class="left text">
          <img src="../assets/oneLogin_icon.png" alt="">
          <span class="text-title">{{$t("home.singleSign")}}</span>
          <span class="text-span">{{$t("home.singleSignText")}}</span>
        </div>
        <div class="left text">
          <img src="../assets/help_icon.png" alt="">
          <span class="text-title">{{$t("home.lenovoHelp")}}</span>
          <span class="text-span">{{$t("home.lenovoHelpText")}}</span>
        </div>
      </div>
    </div>
    <div v-else class="cont">
      <div class="bg-main">
        <el-carousel :height="bannerHeight+'PX'" trigger="click">
          <el-carousel-item v-for="item in imgUrlMobile" :key="item.id">
            <img class="bannertt" style="width: 100%; height: auto;" ref=bannerHeight :src=item.imgV alt=""
              @load="imgload">
            <div v-if="item.id==0" class="bg1-text">
            </div>
            <div v-if="item.id==1" class="bg-text">
            </div>
            <div v-if="item.id==2" class="bg-text">
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="modelList">
        <div class="mode clearfix">
          <div class="images"><img src="../assets/mobile/vip_icon.png" alt=""></div>
          <div class="listText">
            <h3>{{$t("home.lenovoVip")}}</h3>
            <p>{{$t("home.lenovoVipText")}}</p>
            <el-link :underline="false" class="go-more" @click="more" type="primary">{{$t('home.more')}}</el-link>
          </div>
        </div>
        <div class="mode clearfix">
          <div class="images"><img src="../assets/mobile/user_icon.png" alt=""></div>
          <div class="listText">
            <h3>{{$t("home.accountSecurity")}}</h3>
            <p>{{$t("home.accountSecurityText")}}</p>
          </div>
        </div>
        <div class="mode clearfix">
          <div class="images"><img src="../assets/mobile/oneLogin_icon.png" alt=""></div>
          <div class="listText">
            <h3>{{$t("home.singleSign")}}</h3>
            <p>{{$t("home.singleSignText")}}</p>
          </div>
        </div>
        <div class="mode clearfix">
          <div class="images"><img src="../assets/mobile/help_icon.png" alt=""></div>
          <div class="listText">
            <h3>{{$t("home.lenovoHelp")}}</h3>
            <p>{{$t("home.lenovoHelpText")}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['mobile'],
    data() {
      return {
        ifimg: 1,
        languag: 'en_US',
        height: "",
        // 图片父容器高度
        bannerHeight: '',
        imgUrl: [{
          id: 0,
          imgV: require("../assets/" + this.$i18n.locale + "1.png")
        }, {
          id: 1,
          imgV: require("../assets/" + this.$i18n.locale + "2.png")
        }, {
          id: 2,
          imgV: require("../assets/" + this.$i18n.locale + "3.png")
        }],
        imgUrlMobile: [{
          id: 0,
          imgV: require("../assets/mobile/" + this.$i18n.locale + "1.png")
        }, {
          id: 1,
          imgV: require("../assets/mobile/" + this.$i18n.locale + "2.png")
        }, {
          id: 2,
          imgV: require("../assets/mobile/" + this.$i18n.locale + "3.png")
        }]
      }
    },
    methods: {
      more() {
        var url = ""
        if (this.$i18n.locale == "en_US") {
          url = 'https://account.lenovo.com/us/en/'
        } else {
          url = 'https://i.lenovo.com.cn/'
        }
        window.open(url, "_blank")
      },
      imgload() {
        this.$nextTick(() => {
          this.bannerHeight = this.$refs.bannerHeight[0].height
        })
      },
    },
    mounted() {
      this.imgload()
      window.addEventListener('resize', () => {
        this.bannerHeight = this.$refs.bannerHeight[0].height
        this.imgload()
      }, false)
    },
    computed: {
      uplanguage() {
        return this.$i18n.locale
      },
    },
    watch: {
      uplanguage(is) {
            if(this.$i18n.locale != "en_US" && this.$i18n.locale != "zh_CN" && this.$i18n.locale != "zh_HANT"){
                this.$i18n.locale = "zh_CN"
            }
             var _this = this
                _this.imgUrl = [{
                id: 0,
                imgV: require("../assets/" + this.$i18n.locale + "1.png")
                }, {
                id: 1,
                imgV: require("../assets/" + this.$i18n.locale + "2.png")
                }, {
                id: 2,
                imgV: require("../assets/" + this.$i18n.locale + "3.png")
                }]
                _this.imgUrlMobile = [{
                id: 0,
                imgV: require("../assets/mobile/" + this.$i18n.locale + "1.png")
                }, {
                id: 1,
                imgV: require("../assets/mobile/" + this.$i18n.locale + "2.png")
                }, {
                id: 2,
                imgV: require("../assets/mobile/" + this.$i18n.locale + "3.png")
                }]
       
      },
    }
    //   created(){

    //   },
    //   beforeMount(){
    //     this.height = "970PX"
    //     window.onresize = function temp() {
    //     // 通过点语法获取img的height属性值
    //     this.height = `${this.$refs.height['0'].height}PX`
    //     }
    //         //  this.height = $(window).width()*664/1920 + 'PX';
    // },
  }
</script>

<style lang="scss">
  .go-more {
    /* margin-top: 20%; */
    margin-top: 15PX;
    font-size: 16PX;
  }
  .el-link--inner{
    font-size: 16PX !important;
  }
  .text-div .text {
    width: 25%;
    height: 310PX;
    border-right: 1PX solid #DDDDDD;
    padding: 10PX 30PX;
    box-sizing: border-box;
    text-align: center;

    .text-span {
      text-align: left !important;
      display: block;
      font-size: 14PX;
    }

    .text-title {
      margin: 0 auto;
      display: block;
      font-size: 20PX;
      font-weight: bold;
      margin-bottom: 10PX;
    }

    img {
      width: 80PX;
      height: 80PX;
      margin: 0 auto;
      display: block;
      padding-bottom: 10PX;
    }

  }

  .text-div {
    box-sizing: border-box;
    padding: 30PX 10%;
    overflow: hidden;
    width: 100%;

    .text:last-child {
      border: none;
      padding-right: 0;
    }

    .text:first-child {
      padding-left: 0;
    }
  }

  .left {
    float: left;
    display: block;
  }

  .el-carousel__arrow {
    display: none !important;
  }

  .el-carousel__arrow--left {
    display: none !important;
  }

  .el-carousel__arrow--right {
    display: none !important;
  }

  .bg1-text {
    color: #FFFFFF;
    position: absolute;
    top: 30%;
    left: 15%;
  }

  .bg-text {
    color: #FFFFFF;
    position: absolute;
    top: 30%;
    left: 50%;
    margin-left: -465PX;
    text-align: center;
  }

  .bg-img {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .bg-main img {
    width: 100%;
    height: 100%;
    max-width: 1920PX;
    max-height: 970PX;
    margin: 0 auto;
    display: block;

  }

  .bg-main {
    width: 100%;
    height: 100%;
    bottom: 60PX;
  }
  .el-carousel--horizontal {
    overflow-x: inherit !important;
  }

  // 手机端样式
  .modelList {
    font-size: 12PX;
    padding: 30PX 20PX 50PX 20PX;

    .mode {
      border: 1PX solid #DDDDDD;
      border-radius: 4px;
      padding: 15PX;
      margin-bottom: 20PX;
      .images {
        float: left;

        img {
          width: 60PX;
          height: 60PX;
        }
      }
    }

    .listText {
      // float: right;
      margin-left: 80PX;
      // width: 230PX;

      h3 {
        font-size: 16PX;
      }
    }
  }
  .cont{
    padding-bottom: 20PX;
    .bg-main{
      height: 170PX!important;
      overflow: hidden;
    }
  }
</style>
<style scoped>
  .el-footer {
    height: 110PX !important;
    width: 100%;
    background-color: #ffffff;

  }
</style>



// WEBPACK FOOTER //
// src/components/home.vue